<template>
    <v-form ref="form">
        <v-row>
            <v-col cols="12" md="3">
                <v-text-field
                    label="Code"
                    v-model="form.code"
                    dense
                    outlined
                    hide-details="auto"
                    disabled>
                </v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="3">
                <v-text-field
                    label="Purchase Order"
                    :value="form.purchase_order_code"
                    disabled
                    dense
                    outlined
                    hide-details="auto">
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <DatePicker
                    label="Date"
                    dense
                    v-model="form.date"
                    outlined
                    hide-details="auto"
                    />
            </v-col>
            <v-col cols="12" md="3">
                <v-autocomplete
                    label="Warehouse"
                    :items="warehouses"
                    v-model="form.warehouse_id"
                    item-text="display_name"
                    item-value="id"
                    dense
                    outlined
                    hide-details="auto"
                    @update:search-input="searchWarehouses">
                </v-autocomplete>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <GoodReturnFormLine
                    v-for="(d, i) in form.lines" :key="d.key"
                    v-model="form.lines[i]"
                    @delete:line="handleDeleteLine(i)"
                    @update:item-search-input="searchItems"
                    :items="items"
                    />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col>
                <v-btn small depressed block @click="addLine">
                    <v-icon left>mdi-playlist-plus</v-icon>
                    add line
                </v-btn>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import DatePicker from './../common/DatePicker.vue';
import GoodReturnFormLine from './GoodReturnFormLine.vue';
import { v4 as uuid } from 'uuid';
import itemService from './../../services/purchase/item';
import warehouseService from './../../services/purchase/warehouse';
import moment from 'moment';

export default {
    components: {
        DatePicker,
        GoodReturnFormLine
    },
    props: {
        value: Object
    },
    data() {
        return {
            form: {
                code: "--",
                warehouse_id: null,
                purchase_order_code: "--",
                purchase_order_id: null,
                date: moment().format("YYYY-MM-DD"),
                lines: []
            },
            line: {
                item_id: null,
                quantity: null,
                measure_unit_id: null,
                key: null
            },
            items: [],
            warehouses: []
        }
    },
    watch: {
        form: {
            deep: true,
            handler(form) {
                this.$emit("input", {...form, lines: [...form.lines]})
            }
        }
    },
    methods: {
        addLine() {
            this.form.lines.push({...this.line, key: uuid()})
        },
        handleDeleteLine(index) {
            this.form.lines.splice(index, 1)
        },
        searchItems(query) {
            itemService.search(query).then(response => {
                this.items = Array.from(new Set([...this.items, ...response.data]))
            })
        },
        searchWarehouses(query) {
            warehouseService.search(query).then(response => {
                this.warehouses = Array.from(new Set([...this.warehouses, ...response.data]))
            })
        },
        validate() {
            return this.$refs.form.validate();
        },
        fill() {
            let v = this.value;
            this.warehouses = Array.from(new Set([...this.warehouses, v.warehouse]))
            this.form = {
                ...v,
                lines: v.lines.map(line => {
                    this.items = Array.from(new Set([...this.items, line.item]))
                    return {
                        ...line
                    }
                })
            }
        }
    },
    created() {
        if(this.value) {
           this.fill();
        }
    }
}
</script>

<style>

</style>